import ptBR from './pt-BR.json';
import enUS from './en-US.json';

interface DictionaryProps {
  [key: string]: object;
}

export const options: DictionaryProps = { 'pt-BR': ptBR, 'en-US': enUS };
